import { render } from "./Portfolio.vue?vue&type=template&id=2195d490"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"
script.render = render

export default script